import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import { useGetTutorialQuery, useToggleTutorialLikeMutation, useGetTutorialResourcesQuery } from "../../service/main";
import IconButton from "@mui/material/IconButton";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import VideoPopup from "../../Modals/videoPopup";
import Loader from "../../constants/Loader";
import { VideoItem } from "../../types/General";

const formatDuration = (seconds: string | number) => {
    const totalSeconds = Number(seconds);
    if (isNaN(totalSeconds)) return "00:00";

    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const formatted = [
        hrs > 0 ? String(hrs).padStart(2, "0") : null,
        String(mins).padStart(2, "0"),
        String(secs).padStart(2, "0"),
    ]
        .filter(Boolean)
        .join(":");

    return formatted;
};

const VideoCard = ({ item, onClick }: { item: any, onClick: () => void }) => {
    const [isLiked, setIsLiked] = useState(item?.isLiked ?? false);
    const [likeCount, setLikeCount] = useState(item?.likeCount ?? 0);
    const [toggleTutorialLike, { isLoading: isLiking }] = useToggleTutorialLikeMutation();

    const handleTutorialLike = async (e: React.MouseEvent) => {
        e.stopPropagation();
        const prevIsLiked = isLiked;
        const prevCount = likeCount;

        setIsLiked(!prevIsLiked);
        setLikeCount(prevIsLiked ? prevCount - 1 : prevCount + 1);

        try {
            await toggleTutorialLike(item.id).unwrap();
        } catch (error) {
            console.error(error);
            setIsLiked(prevIsLiked);
            setLikeCount(prevCount);
        }
    };

    return (
        <div
            className="video-card"
            onClick={onClick}
        >
            <div
                className="thumb"
                style={{
                    backgroundImage: item.thumbnail
                        ? `url(${item.thumbnail})`
                        : undefined,
                }}
            >
                <span className="play-btn">▶</span>
                <span className="duration">
                    {formatDuration(item.duration)}
                </span>
            </div>

            <div style={{ padding: '12px' }}>
                <h4 style={{ margin: '0 0 8px 0', fontSize: '16px' }}>{item?.title || "-"}</h4>
                {item?.description && (
                    <p style={{ margin: '0 0 10px 0', fontSize: '13px', color: '#666', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {item.description}
                    </p>
                )}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {item?.createdAt ? (
                        <span style={{ fontSize: '12px', color: '#999' }}>
                            {new Date(item.createdAt).toLocaleDateString()}
                        </span>
                    ) : <span />}
                    <IconButton disabled={isLiking} onClick={handleTutorialLike} size="small" style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px', color: '#666' }}>
                        {isLiked ? <ThumbUpIcon sx={{ color: '#d3b88c' }} fontSize="small" /> : <ThumbUpOutlinedIcon fontSize="small" />}
                        {likeCount > 0 && <span>{likeCount}</span>}
                    </IconButton>
                </div>
            </div>
        </div>
    );
};

const VideoTutorials = () => {
    const { data: tutorial, isLoading } = useGetTutorialQuery({});
    const tutorialData: VideoItem[] = tutorial?.data?.list || [];

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedVideo, setSelectedVideo] = useState<VideoItem | null>(null);
    const [openPopup, setOpenPopup] = useState(false);

    const { data: tutorialDetailData, isFetching: isDetailLoading } = useGetTutorialResourcesQuery(selectedVideo?.id || "", { skip: !selectedVideo });
    const detailVideo = tutorialDetailData?.data || selectedVideo;

    const handleVideoClick = (item: VideoItem) => {
        setSelectedVideo(item);
        setOpenPopup(true);
    };

    return (
        <>
            <Loader isLoad={isLoading} />
            <div className="main_title">
                <h1>Video Tutorials View</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/admin-support")}>
                        Admin Support Management
                    </button>
                    - Video Tutorials
                </p>
            </div>
            
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                </div>

                <div className="video-grid">
                    {tutorialData?.length
                        ? tutorialData?.map((item, i) => (
                            <VideoCard key={i} item={item} onClick={() => handleVideoClick(item)} />
                        ))
                        : null}
                </div>
            </div>

            <VideoPopup
                open={openPopup}
                onClose={() => { setOpenPopup(false); setSelectedVideo(null); }}
                video={detailVideo}
                isLoading={isDetailLoading}
            />
        </>
    );
};
export default VideoTutorials;
